<div class="row" *ngIf="isComercial">
  <div class="col-lg col-md col-xs col-xl col-sm w-100">
    <mat-card class="mat-elevation-z8 w-100">
      <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
        <div class="row">
          <div class="col-lg col-md col-xs col-xl col-sm">
            <p class="tituloLeft">{{step}}</p>
          </div>
          <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
            <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
              *ngIf="!collapseCard"></i>
            <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
              *ngIf="collapseCard"></i>
          </div>
        </div>
        <mat-card-content *ngIf="!collapseCard">

          <div class="row pt-3">

            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Site Recebimento</mat-label>
                <input matInput id="txtSiteRecebimento" #txtEspecie maxlength="10" formControlName="Site_recebimento"
                  [readonly]="isReadyOnly" [class.InputBlockColor]="isReadyOnly" required>
                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadyOnly"></i>
                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadyOnly"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintSiteCdr}}</mat-hint>
                <!-- <mat-hint align="end">{{txtEspecie.value.length}} / 10</mat-hint> -->
                <mat-error>{{hasErrorFormControl(formulario.controls.Site_recebimento)}}</mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">{{hintSafraLabel}}</mat-label>
                <input matInput id="txtSafra" #txtSafra maxlength="8" formControlName="Safra" class="InputBlockColor"
                  readonly required>
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintSafra}}</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Safra)}}</mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Site Origem</mat-label>
                <input matInput id="txtSiteOrigem" #txtSiteOrigem maxlength="20" formControlName="Site_origem" readonly
                  class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtSiteOrigem.value.length}} / 20</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Site_origem)}}</mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Tipo Colheita</mat-label>
                <input matInput id="txtTipoColheita" #txtTipoColheita maxlength="10" formControlName="Tipo_colheita"
                  readonly class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                </mat-hint>
                <mat-hint align="end">{{txtTipoColheita.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Tipo_colheita)}}</mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Contrato Jurídico</mat-label>
                <input matInput id="txtContratoCampo" #txtContratoCampo maxlength="100" formControlName="Contrato_campo"
                  readonly class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">
                  {{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtContratoCampo.value.length}} / 100</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Contrato_campo)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Contrato Campo</mat-label>
                <input matInput id="txtContratoCampo2" #txtContratoCampo2 maxlength="40"
                  formControlName="Contrato_campo_2" readonly class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">
                  {{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtContratoCampo2.value.length}} / 40</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Contrato_campo_2)}}</mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Nº de Campo (Básica)</mat-label>
                <input matInput id="txtNumCampo" #txtNumCampo maxlength="10" formControlName="Num_campo" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 0 }" [readonly]="isReadyOnly"
                  [class.InputBlockColor]="isReadyOnly">
                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadyOnly"></i>
                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadyOnly"></i>
                <mat-hint align="start" class="InputLabelDetailsColor" *ngIf="isReadyOnly">
                  {{hintSiteCdr}}</mat-hint>
                <mat-hint align="start" class="InputLabelDetailsColor" *ngIf="!isReadyOnly">
                  {{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtNumCampo.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Num_campo)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Híbrido RNC / Linhagem</mat-label>
                <input matInput id="txtHibrido" #txtHibrido maxlength="40" formControlName="Hibrido_rnc_linhagem"
                  class="InputBlockColor" readonly>
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                </mat-hint>
                <mat-hint align="end">{{txtHibrido.value.length}} / 40</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Hibrido_rnc_linhagem)}}</mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Geração (Básica)</mat-label>
                <input matInput id="txtGeracao" #txtGeracao maxlength="20" readonly formControlName="Geracao"
                  [readonly]="isReadyOnly" [class.InputBlockColor]="isReadyOnly">
                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadyOnly"></i>
                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadyOnly"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintSiteCdr}}</mat-hint>
                <mat-hint align="end">{{txtGeracao.value.length}} / 20</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Geracao)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Espécie (Básica)</mat-label>
                <input matInput id="txtEspecie" #txtEspecie maxlength="10" formControlName="Especie"
                  [readonly]="isReadyOnly" [class.InputBlockColor]="isReadyOnly">
                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadyOnly"></i>
                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadyOnly"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintSiteCdr}}</mat-hint>
                <mat-hint align="end">{{txtEspecie.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Especie)}}</mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Início Enchimento Data</mat-label>
                <input matInput id="txtIniEnchimentoData" #txtIniEnchimentoData maxlength="10" mask="d0/M0/0000"
                  formControlName="Inicio_enchimento_data" [dropSpecialCharacters]="false" (blur)="makeCalculations()">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">
                  {{hintDate}}</mat-hint>
                <mat-hint align="end">{{txtIniEnchimentoData.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Inicio_enchimento_data)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Início Enchimento Hora</mat-label>
                <input matInput id="txtIniEnchimentoHora" #txtIniEnchimentoHora maxlength="5"
                  [dropSpecialCharacters]="false" mask="Hh:m0" formControlName="Inicio_enchimento_hora"
                  (blur)="makeCalculations()">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">
                  {{hintHour}}</mat-hint>
                <mat-hint align="end">{{txtIniEnchimentoHora.value.length}} / 5</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Inicio_enchimento_hora)}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Término Enchimento Data</mat-label>
                <input matInput id="txtFimEnchimentoData" #txtFimEnchimentoData maxlength="10" mask="d0/M0/0000"
                  formControlName="Termino_enchimento_data" [dropSpecialCharacters]="false" (blur)="makeCalculations()">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">
                  {{hintDate}}</mat-hint>
                <mat-hint align="end">{{txtFimEnchimentoData.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Termino_enchimento_data)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Término Enchimento Hora</mat-label>
                <input matInput id="txtFimEnchimentoHora" #txtFimEnchimentoHora maxlength="5"
                  [dropSpecialCharacters]="false" mask="Hh:m0" formControlName="Termino_enchimento_hora"
                  (blur)="makeCalculations()">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">
                  {{hintHour}}</mat-hint>
                <mat-hint align="end">{{txtFimEnchimentoHora.value.length}} / 5</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Termino_enchimento_hora)}}
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Peso Total RW (kg)</mat-label>
                <input matInput id="txtPesoRw" #txtPesoRw maxlength="10" formControlName="Peso_rw_kg_total" currencyMask
                  readonly [readonly]="isReadyOnly" [class.InputBlockColor]="isReadyOnly">
                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadyOnly"></i>
                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadyOnly"></i>
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">
                  {{hintNumber}} - Se o caminhão for
                  fracionado, usar 50% do valor
                </mat-hint>
                <mat-hint align="end">{{txtPesoRw.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Peso_rw_kg_total)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg-6 col-md-6">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Umidade média CERAR (%)</mat-label>
                <input matInput id="txtUmidMediaCerar" #txtUmidMediaCerar maxlength="5" currencyMask readonly
                  [readonly]="isReadyOnly" [class.InputBlockColor]="isReadyOnly" formControlName="Umidade_media_cerar"
                  currencyMask>
                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadyOnly"></i>
                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadyOnly"></i>
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">
                  {{hintNumber}}
                </mat-hint>
                <mat-hint align="end">{{txtUmidMediaCerar.value.length}} / 5</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Umidade_media_cerar)}}</mat-error>
              </mat-form-field>
            </div>
          </div>
        </mat-card-content>
      </form>
    </mat-card>
  </div>
</div>

<div class="row" *ngIf="isBasica">
  <div class="col-lg col-md col-xs col-xl col-sm w-100">
    <mat-card class="mat-elevation-z8 w-100">
      <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
        <div class="row">
          <div class="col-lg col-md col-xs col-xl col-sm">
            <p class="tituloLeft">{{step}}</p>
          </div>
          <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
            <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
              *ngIf="!collapseCard"></i>
            <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
              *ngIf="collapseCard"></i>
          </div>
        </div>
        <mat-card-content *ngIf="!collapseCard">

          <div class="row pt-3">

            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Site Recebimento</mat-label>
                <input matInput id="txtSiteRecebimento" #txtEspecie maxlength="10" formControlName="Site_recebimento"
                  [readonly]="isReadyOnly" [class.InputBlockColor]="isReadyOnly" required>
                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadyOnly"></i>
                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadyOnly"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintSiteCdr}}</mat-hint>
                <!-- <mat-hint align="end">{{txtEspecie.value.length}} / 10</mat-hint> -->
                <mat-error>{{hasErrorFormControl(formulario.controls.Site_recebimento)}}</mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">{{hintSafraLabel}}</mat-label>
                <input matInput id="txtSafra" #txtSafra maxlength="8" formControlName="Safra" class="InputBlockColor"
                  readonly required>
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintSafra}}</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Safra)}}</mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Site Origem</mat-label>
                <input matInput id="txtSiteOrigem" #txtSiteOrigem maxlength="20" formControlName="Site_origem" readonly
                  class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtSiteOrigem.value.length}} / 20</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Site_origem)}}</mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Tipo Colheita</mat-label>
                <input matInput id="txtTipoColheita" #txtTipoColheita maxlength="10" formControlName="Tipo_colheita"
                  readonly class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                </mat-hint>
                <mat-hint align="end">{{txtTipoColheita.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Tipo_colheita)}}</mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Contrato Jurídico</mat-label>
                <input matInput id="txtContratoCampo" #txtContratoCampo maxlength="100" formControlName="Contrato_campo"
                  readonly class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">
                  {{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtContratoCampo.value.length}} / 100</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Contrato_campo)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Contrato Campo</mat-label>
                <input matInput id="txtContratoCampo2" #txtContratoCampo2 maxlength="40"
                  formControlName="Contrato_campo_2" readonly class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">
                  {{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtContratoCampo2.value.length}} / 40</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Contrato_campo_2)}}</mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Nº de Campo (Básica)</mat-label>
                <input matInput id="txtNumCampo" #txtNumCampo maxlength="10" formControlName="Num_campo" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 0 }" [readonly]="isReadyOnly"
                  [class.InputBlockColor]="isReadyOnly">
                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadyOnly"></i>
                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadyOnly"></i>
                <mat-hint align="start" class="InputLabelDetailsColor" *ngIf="isReadyOnly">
                  {{hintSiteCdr}}</mat-hint>
                <mat-hint align="start" class="InputLabelDetailsColor" *ngIf="!isReadyOnly">
                  {{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtNumCampo.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Num_campo)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Híbrido RNC / Linhagem</mat-label>
                <input matInput id="txtHibrido" #txtHibrido maxlength="40" formControlName="Hibrido_rnc_linhagem"
                  class="InputBlockColor" readonly>
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                </mat-hint>
                <mat-hint align="end">{{txtHibrido.value.length}} / 40</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Hibrido_rnc_linhagem)}}</mat-error>
              </mat-form-field>
            </div>


          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Gleba</mat-label>
                <input matInput id="txtGleba" #txtGleba maxlength="10" formControlName="gleba" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtGleba.value.length}} / 5</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.gleba)}}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Geração (Básica)</mat-label>
                <input matInput id="txtGeracao" #txtGeracao maxlength="20" readonly formControlName="Geracao"
                  [readonly]="isReadyOnly" [class.InputBlockColor]="isReadyOnly">
                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadyOnly"></i>
                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadyOnly"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintSiteCdr}}</mat-hint>
                <mat-hint align="end">{{txtGeracao.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Geracao)}}</mat-error>
              </mat-form-field>
            </div>

          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Espécie (Básica)</mat-label>
                <input matInput id="txtEspecie" #txtEspecie maxlength="10" formControlName="Especie"
                  [readonly]="isReadyOnly" [class.InputBlockColor]="isReadyOnly">
                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadyOnly"></i>
                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadyOnly"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintSiteCdr}}</mat-hint>
                <mat-hint align="end">{{txtEspecie.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Especie)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Início Enchimento Data</mat-label>
                <input matInput id="txtIniEnchimentoData" #txtIniEnchimentoData maxlength="10" mask="d0/M0/0000"
                  formControlName="Inicio_enchimento_data" [dropSpecialCharacters]="false" (blur)="makeCalculations()">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">
                  {{hintDate}}</mat-hint>
                <mat-hint align="end">{{txtIniEnchimentoData.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Inicio_enchimento_data)}}
                </mat-error>
              </mat-form-field>
            </div>

          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Início Enchimento Hora</mat-label>
                <input matInput id="txtIniEnchimentoHora" #txtIniEnchimentoHora maxlength="5"
                  [dropSpecialCharacters]="false" mask="Hh:m0" formControlName="Inicio_enchimento_hora"
                  (blur)="makeCalculations()">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">
                  {{hintHour}}</mat-hint>
                <mat-hint align="end">{{txtIniEnchimentoHora.value.length}} / 5</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Inicio_enchimento_hora)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Término Enchimento Data</mat-label>
                <input matInput id="txtFimEnchimentoData" #txtFimEnchimentoData maxlength="10" mask="d0/M0/0000"
                  formControlName="Termino_enchimento_data" [dropSpecialCharacters]="false" (blur)="makeCalculations()">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">
                  {{hintDate}}</mat-hint>
                <mat-hint align="end">{{txtFimEnchimentoData.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Termino_enchimento_data)}}
                </mat-error>
              </mat-form-field>
            </div>

          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Término Enchimento Hora</mat-label>
                <input matInput id="txtFimEnchimentoHora" #txtFimEnchimentoHora maxlength="5"
                  [dropSpecialCharacters]="false" mask="Hh:m0" formControlName="Termino_enchimento_hora"
                  (blur)="makeCalculations()">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">
                  {{hintHour}}</mat-hint>
                <mat-hint align="end">{{txtFimEnchimentoHora.value.length}} / 5</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Termino_enchimento_hora)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Peso Total RW (kg)</mat-label>
                <input matInput id="txtPesoRw" #txtPesoRw maxlength="10" formControlName="Peso_rw_kg_total" currencyMask
                  readonly [readonly]="isReadyOnly" (blur)="makeCalculations()" [class.InputBlockColor]="isReadyOnly">
                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadyOnly"></i>
                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadyOnly"></i>
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">
                  {{hintNumber}} - Se o caminhão for
                  fracionado, usar 50% do valor
                </mat-hint>
                <mat-hint align="end">{{txtPesoRw.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Peso_rw_kg_total)}}</mat-error>
              </mat-form-field>
            </div>

          </div>

          <div class="row pt-3">
            <div class="col-lg-6 col-md-6">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Umidade média CERAR (%)</mat-label>
                <input matInput id="txtUmidMediaCerar" #txtUmidMediaCerar maxlength="5" currencyMask readonly
                  [readonly]="isReadyOnly" [class.InputBlockColor]="isReadyOnly" formControlName="Umidade_media_cerar"
                  currencyMask>
                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadyOnly"></i>
                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadyOnly"></i>
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">
                  {{hintNumber}}
                </mat-hint>
                <mat-hint align="end">{{txtUmidMediaCerar.value.length}} / 5</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.Umidade_media_cerar)}}</mat-error>
              </mat-form-field>
            </div>
          </div>
        </mat-card-content>
      </form>
    </mat-card>
  </div>
</div>


<div class="row" *ngIf="isPreBasica">
  <div class="col-lg col-md col-xs col-xl col-sm w-100">
    <mat-card class="mat-elevation-z8 w-100">
      <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
        <div class="row">
          <div class="col-lg col-md col-xs col-xl col-sm">
            <p class="tituloLeft">{{step}}</p>
          </div>
          <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
            <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
              *ngIf="!collapseCard"></i>
            <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
              *ngIf="collapseCard"></i>
          </div>
        </div>
        <mat-card-content *ngIf="!collapseCard">

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Site Recebimento
                  <span class="InputRequired">{{required}}</span>
                </mat-label>
                <input matInput id="txtSiteRecebimento" #txtEspecie maxlength="10" formControlName="site_recebimento"
                  [readonly]="isReadyOnly" [class.InputBlockColor]="isReadyOnly" required>
                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadyOnly"></i>
                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadyOnly"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintSiteCdr}}</mat-hint>
                <!-- <mat-hint align="end">{{txtEspecie.value.length}} / 10</mat-hint> -->
                <mat-error>{{hasErrorFormControl(formulario.controls.site_recebimento)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">{{hintSafraPreBasicaLabel}}</mat-label>
                <input (blur)="changeSafra($event)" matInput id="txtSafra" #txtSafra maxlength="5"
                  formControlName="safra_basica" required>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintSafraPreBasica}}</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.safra)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Cerar
                  <span class="InputRequired">{{required}}</span>
                </mat-label>
                <input matInput id="txtUmidMediaCerar" (blur)="changeSafra($event)" #txtUmidMediaCerar
                  formControlName="cerar_basica" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                <mat-hint align="start" class="InputLabelDetailsColor">
                  {{hintNumber}}
                </mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.cerar_basica)}}</mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Nº de Campo
                  <span class="InputRequired">{{required}}</span>
                </mat-label>
                <input (blur)="changeSafra($event)" matInput id="txtNumCampo" #txtNumCampo maxlength="10"
                  formControlName="n_de_campo_basica" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 0 }" [readonly]="isEdit"
                  [class.InputBlockColor]="isEdit" required>
                <i *ngIf="isEdit" matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="end">{{txtNumCampo.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.n_de_campo_basica)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Gleba
                </mat-label>

                <input matInput id="txtGleba" #txtGleba maxlength="10" formControlName="gleba" readonly
                  [readonly]="isReadyOnly" [class.InputBlockColor]="isReadyOnly">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                <mat-hint align="end">{{txtGleba.value.length}} / 5</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.gleba)}}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Nota de Ardida
                  <span class="InputRequired">{{required}}</span>
                </mat-label>
                <input matInput id="txtGleba" #txtGleba maxlength="10" formControlName="nota_ardida" readonly
                  [class.InputBlockColor]="true">
                <i matSuffix class="{{iconEnableField}}"></i>


                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtGleba.value.length}} / 5</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.nota_ardida)}}
                </mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Geração
                  <span class="InputRequired">{{required}}</span>
                </mat-label>
                <input matInput id="txtGeracao" #txtGeracao maxlength="20" readonly formControlName="geracao_basica"
                  [readonly]="isReadyOnly" [class.InputBlockColor]="isReadyOnly">
                <i matSuffix class="{{iconDisableField}}" *ngIf="isReadyOnly"></i>
                <i matSuffix class="{{iconEnableField}}" *ngIf="!isReadyOnly"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintSiteCdr}}</mat-hint>
                <mat-hint align="end">{{txtGeracao.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.geracao_basica)}}</mat-error>
              </mat-form-field>
            </div>


          </div>
          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Número da Caixa
                  <span class="InputRequired">{{required}}</span></mat-label>
                <input (blur)="changeSafra($event)" matInput id="txtNumCaixa" #txtNumCaixa maxlength="10"
                  formControlName="numero_caixa" currencyMask [options]="{ thousands: '.', decimal: ',', precision: 0 }"
                  [readonly]="isEdit" [class.InputBlockColor]="isEdit">

                <i *ngIf="isEdit" matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="end">{{txtNumCaixa.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.numero_caixa)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Houve troca de caixa?
                  <span class="InputRequired">{{required}}</span></mat-label>

                <mat-select (selectionChange)="changeHouveTroca()" #txtHouveTrocaCaixa
                  formControlName="houve_troca_caixa" disableOptionCentering>
                  <mat-option *ngFor="let item of listHouveTrocaCaixa" [value]="item.name">
                    {{item.name | uppercase}}
                  </mat-option>
                </mat-select>


                <mat-error>{{hasErrorFormControl(formulario.controls.houve_troca_caixa)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md" *ngIf="isHouveTroca">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Número novo de Caixa
                  <span class="InputRequired">{{required}}</span></mat-label>
                <input matInput id="txtNumNovoCaixa" #txtNumNovoCaixa maxlength="10" formControlName="numero_novo_caixa"
                  currencyMask [options]="{ thousands: '.', decimal: ',', precision: 0 }">

                <i *ngIf="isEdit" matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="end">{{txtNumNovoCaixa.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.numero_novo_caixa)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Controle de caixa
                  <span class="InputRequired">{{required}}</span></mat-label>
                <input matInput id="txtControleCaixa" #txtControleCaixa maxlength="10" formControlName="controle_caixa"
                  currencyMask [options]="{ thousands: '.', decimal: ',', precision: 0 }" [readonly]="true"
                  [class.InputBlockColor]="true">

                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="end">{{txtControleCaixa.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.controle_caixa)}}</mat-error>
              </mat-form-field>
            </div>

          </div>


          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Lote Rw - Exemplo: E1DGRAO001 </mat-label>
                <input matInput id="txtLoteRw" #txtLoteRw maxlength="10" formControlName="lote_rw" readonly
                  [readonly]="isReadyOnly" [class.InputBlockColor]="isReadyOnly">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintLoteDsPet}}</mat-hint>
                <mat-hint align="end">{{txtLoteRw.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.lote_rw)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Umidade de Recebimento
                  <span class="InputRequired">{{required}}</span></mat-label>
                <input matInput id="txtUmidadeRecebimento" #txtUmidadeRecebimento maxlength="5"
                  formControlName="umidade_recebimento" currencyMask
                  [options]="{ thousands: '.', decimal: ',', precision: 2 }" readonly [readonly]="isReadyOnly"
                  [class.InputBlockColor]="isReadyOnly">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                </mat-hint>
                <mat-hint align="end">{{txtUmidadeRecebimento.value.length}} / 5</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.umidade_recebimento )}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Tipo Colheita
                  <span class="InputRequired">{{required}}</span></mat-label>
                <input matInput id="txtTipoColheita" #txtTipoColheita maxlength="10" formControlName="tipo_colheita"
                  readonly class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}
                </mat-hint>
                <mat-hint align="end">{{txtTipoColheita.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.tipo_colheita)}}</mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">

            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Contrato Jurídico
                  <span class="InputRequired">{{required}}</span></mat-label>
                <input matInput id="txtContratoCampo" #txtContratoCampo maxlength="100" formControlName="contrato_campo"
                  readonly class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">
                  {{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtContratoCampo.value.length}} / 100</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.contrato_campo)}}</mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg col-md">
              <!--  novo campo Manufatura/linhagem -->
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Manufatura/linhagem
                  <span class="InputRequired">{{required}}</span></mat-label>
                <input matInput id="txtManufatura" #txtManufatura maxlength="80" [readonly]="true"
                  formControlName="hibrido_rnc_linhagem" class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtManufatura.value.length}} / 80</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.hibrido_rnc_linhagem)}}</mat-error>
              </mat-form-field>
            </div>

            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Cooperante
                  <span class="InputRequired">{{required}}</span></mat-label>
                <input matInput id="txtCooperante" #txtCooperante maxlength="80" [readonly]="true"
                  formControlName="cooperante" class="InputBlockColor">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtCooperante.value.length}} / 80</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.cooperante)}}</mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row pt-3">
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Peso RW caixa(kg)
                  <span class="InputRequired">{{required}}</span></mat-label>
                <input matInput id="txtPesoRw" #txtPesoRw maxlength="10" formControlName="peso_rw_kg_total" readonly
                  class="InputBlockColor" currencyMask [options]="{ thousands: '.', decimal: ',', precision: 0 }">
                <i matSuffix class="{{iconDisableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                <mat-hint align="end">{{txtPesoRw.value.length}} / 10</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.peso_rw_kg_total)}}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-lg col-md">
              <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
                <mat-label class="InputLabelColor">Altura Camada (m)
                  <span class="InputRequired">{{required}}</span></mat-label>
                <input matInput id="txtAlturaCamada" #txtAlturaCamada maxlength="5" formControlName="altura_camada_m"
                  currencyMask [options]="{ thousands: '.', decimal: ',', precision: 0 }" readonly
                  [readonly]="isReadyOnly" [class.InputBlockColor]="isReadyOnly">
                <i matSuffix class="{{iconEnableField}}"></i>
                <mat-hint align="start" class="InputLabelDetailsColor">
                  {{hintNumber}}
                </mat-hint>
                <mat-hint align="end">{{txtAlturaCamada.value.length}} / 5</mat-hint>
                <mat-error>{{hasErrorFormControl(formulario.controls.altura_camada_m)}}</mat-error>
              </mat-form-field>
            </div>

          </div>
        </mat-card-content>
      </form>
    </mat-card>
  </div>
</div>